import React from 'react';
import { short as Logo } from '../parts/logo.jsx';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';

import { toggleCart, closeCart } from '../../actions';
import classNames from 'classnames';

const Header = props => {
  const _handleHeaderClick = e => {
    document.body.classList.remove('job-overview-active');
    props.closeCart();
  }
  const _handleCartClick = e => {
    props.toggleCart();
  }
  return <header className={classNames('header', {
    'header--cart': props.cartActive || props.dark,
    'header--white': props.white
  })}>
    <div className="inner inner--flex">
      <div className="header__logo">
        <NavLink exact to="/" onClick={e => _handleHeaderClick(e)}><Logo /></NavLink>
      </div>
      {props.label ?
        <div className="header__label">
          {props.label}
        </div>
        :
        <div className="header__menu header__menu--primary">
          <ul>
            <li><NavLink exact to="/" activeClassName="active" onClick={e => _handleHeaderClick(e)}>Latest</NavLink></li>
            <li><NavLink to="/artists" activeClassName="active" onClick={e => _handleHeaderClick(e)}>Artists</NavLink></li>
            <li><NavLink to="/shop" activeClassName="active" onClick={e => _handleHeaderClick(e)}>Shop</NavLink></li>
            <li>
              <span className={classNames('a cart-toggle', {
                'active': props.cartActive && props.cartQuantity > 0,
                'disabled': props.cartQuantity < 1,
                })} onClick={e => _handleCartClick(e)}>
                Cart
                {props.cartQuantity > 0 &&
                  <span className="cart-count">{props.cartQuantity.toString().padStart(2, 0)}</span>
                }
              </span>
            </li>
          </ul>
        </div>
      }
      <div className="header__menu header__menu--secondary">
        <ul>
          <li><NavLink to="/information" activeClassName="active" onClick={e => _handleHeaderClick(e)}>Information</NavLink></li>
        </ul>
      </div>
    </div>
  </header>;
};


const mapStateToProps = (state, ownProps) => {
  return {
    cartActive: state.cart.active,
    cartQuantity: state.cart.quantity
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    toggleCart: () => {
      dispatch(toggleCart());
    },
    closeCart: () => {
      dispatch(closeCart());
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Header);
